import React, { useEffect, useState, useCallback } from "react";
import {
  Text,
  HStack,
  Spinner,
} from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { isNilOrEmpty, useSessionCtx, noop } from "utils";
import { AddPaypalRedirect } from "components/Paypal";
import { usePaypalResponseHandler } from "./usePaypalResponseHandler";

export const Paypal = ({ onComplete, onReady = noop }) => {
  const [redirectErr, setRedirectErr] = useState(null);
  const {
    sessionCtx: { flowState },
  } = useSessionCtx();

  usePaypalResponseHandler(onComplete);
  useEffect(onReady, [onReady]);

  const onRedirectErrorHandler = useCallback((err) => {
    setRedirectErr(err);
  }, [setRedirectErr]);

  return (
    <div data-testid="pm-add-paypal">
      {isNilOrEmpty(flowState) && (
        <>
          {!redirectErr && (
            <HStack justify="flex-start" align="center">
              <Spinner size="sm" speed="0.5s" emptyColor="gray.200" color="integrator.500" />
              <Text as="i" color="tertiaryText">
                <FormattedMessage
                  defaultMessage="Redirecting you to PayPal..."
                  description="Redirect message"
                />
              </Text>
            </HStack>
          )}
          <AddPaypalRedirect onError={onRedirectErrorHandler} />
        </>
      )}
    </div>
  );
};
